import React, { useEffect, useState } from 'react';
import { User } from '../../types';
import { buildGreeting, readLoginGreeting } from '../../utils/greeting';
type LoginGreetingProps = {
  user: User;
};
export function LoginGreeting({
  user
}: LoginGreetingProps) {
  const [now, setNow] = useState(() => new Date());
  const returning = readLoginGreeting(user.id)?.returning ?? false;
  useEffect(() => {
    const timer = window.setInterval(() => setNow(new Date()), 60000);
    return () => window.clearInterval(timer);
  }, []);
  return <div className="min-w-0" data-id="element-87" data-mp="372ixyk4ohcut">
      <p className="truncate text-base font-semibold text-chrome-header-ink sm:text-lg" aria-live="polite" data-id="element-88" data-mp="372slm12937xc">
        {buildGreeting(user.fullName, returning, now)}
      </p>
      <p className="hidden truncate text-xs text-chrome-header-muted sm:block" data-id="element-89" data-mp="2xby234ge2mfl">
        {now.toLocaleDateString(undefined, {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      })}
      </p>
    </div>;
}